var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.getValue,"item-value":"code","item-text":"text","clearable":"","prepend-icon":_vm.getIcon,"dense":_vm.getDensity,"items":_vm.inpt_type_select,"label":_vm.label},on:{"input":_vm.updateData,"click:clear":function($event){return _vm.onClear()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }